import styled from "styled-components";
import { fontFamilyDefault } from "styles/typography";
import { colors } from "styles/variables";
import { AllActivitiesProps } from "./types";

export const ActivityFilterDiv = styled.div`
  min-width: 250px;
  font-family: ${fontFamilyDefault};
  margin-right: 20px;
`;

export const AllActivitiesDiv = styled.div<AllActivitiesProps>`
  background-color: ${(props) => (props.selected ? "white" : colors.paleBlue)};
  padding: 0 0 6px 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-family: "Museo Sans", sans-serif;
  padding: 5px 10px;

  &:hover {
    cursor: pointer;
  }
`;
